import axios from "axios";
import { StartTask, TaskData, TaskRecord, TaskResponse, TaskStatus } from "../types/Task";
import { TaskSharp } from "@mui/icons-material";

export const addTask = async (data: TaskData) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    console.log(data)

    return await axios.post("/api/tasks/", data).catch(e => {
        return {
            status: e.response.status,
            data: e.response.data,
        };
   }) as TaskResponse;
}

export const startTask = async (data: StartTask) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {status: 200,
    data: {}} as TaskResponse
}

export const getTask = async (id: number) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    return {status: 200,
        data: {}} as TaskResponse
}

export const cancelTask = async (data: TaskRecord) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    return {status: 200,
        data: {}} as TaskResponse
}

export const listTask = async () => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {status: 200,
        data: []} as TaskResponse
}

export const listCurrentLocationTask = async (locationId: number) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return [] as TaskRecord[]
}

export const listTaskRecords = async () => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {status: 200,
        data: []}as TaskResponse
}

export const updateTaskRecord = async (taskRecord: TaskRecord) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {status: 200,
        data: {}} as TaskResponse
}